<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body card-body-custom">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <iframe
              :src="mData.dataDefault.links"
              width="100%"
              frameborder="0"
              style="padding: 0 20px ;z-index: 10; height:calc(100vh - 169px);"
            ></iframe>
          </b-row>
          <div class="div-btn text-center mt-2 padding">
            <el-popover
              class="popover-css"
              style="color: #fff;"
              placement="top"
              width="280"
              trigger="click"
            >
              <el-link href="javascript:" class="warning-text" slot="reference">Lưu ý nếu gặp lỗi</el-link>
              <div class="alert-message">
                <p>
                  Một số trường hợp đặc thù khi sử dụng các trình duyệt như Google Chrome, Cốc Cốc, Safari, Microsoft Edge trên các
                hệ điều hành Windows hoặc MacOS phiên bản thấp có thể gặp phải lỗi không thể thực hiện đánh giá an toàn ngày.
                </p>
                Nếu bạn gặp phải tình huống này, xin vui lòng sử dụng Trình duyệt Firefox (<a href="https://www.mozilla.org/vi/firefox/download/thanks/" target="_blank">tải tại đây</a>) để thực hiện đánh giá an toàn ngày!
              </div>
            </el-popover>
            <el-button 
              class="btn-back"
              @click="fn_go()" 
              type="info" 
              plain
            >
              {{aLang.c_back}}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DangKyDDATModel from "./DangKyDDATModel";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import AccountApi from "../../../moduleApi/AccountApi";
import SurveyApi from "../../../moduleApi/SurveyApi";
import VungDichModel from "../VungDich/VungDichModel";
import VungDichApi from "../../../moduleApi/VungDichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "update",
        moduleName: "DangKyDDAT",
        dataDefault: {
          roles: DataService.rolesInForm,
          links: "",
          iframe: {
            src: "",
            style: null,
            wrapperStyle: null,
          },
        },
        dataForm: MethodService.copyObject(DangKyDDATModel.dataForm),
        validForm: DangKyDDATModel.validForm,
        dialog: {},
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await DiemDenAnToanApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await DiemDenAnToanApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DiemDenAnToanApi.findById(id);
      this.mData.dataForm = res.result;

      let objJsonB64 = "";
      let prefillSurvey;
      if (res.result.du_lieu_khai_bao) {
        objJsonB64 = Buffer.from(
          JSON.stringify(res.result.du_lieu_khai_bao)
        ).toString("base64");
        prefillSurvey = await SurveyApi.getPrefillId({ data: objJsonB64 });
      }
      let pathLocation =
        location.protocol + "//" + location.host + "/admin/DangKyDDAT/success?src=khaibaoantoan";

      let params = {
        prefillData: prefillSurvey.result,
        appCode: "Tourism",
        callbackUrl: pathLocation,
        env: window.MyConfig.surveyDailyEnv
      };

      let resCode = await AccountApi.generateHashCode(params);
      // console.log(resCode.result);

      this.mData.dataDefault.links +=
        window.MyConfig.surveyEnv +
        "prefillId=" +
        prefillSurvey.result +
        "&hashCode=" +
        resCode.result.toString().toLowerCase() +
        "&appCode=Tourism" +        
        "&env=" + window.MyConfig.surveyDailyEnv + 
        "&callbackUrl=" +
        encodeURIComponent(pathLocation);
      // debugger;
    },
    async fn_getDailyDataById(id) {
      let res = await DiemDenAnToanApi.findById(id);
      this.mData.dataForm = res.result;

      //debugger;
      let objJsonB64 = "";
      let prefillSurvey;
      if (res.result.du_lieu_khai_bao) {
        let tinhTrang = undefined;
        try {
          let vungDich = await VungDichApi.list({
            filters: ["province_id=" + res.result.thong_tin_chung.dia_chi.tinh_id]
          });
          tinhTrang = (VungDichModel.epidemic_status.find(item => item.code == vungDich.result[0].epidemic_status) || {}).text;
        }
        catch(e) {
          console.error(e);
        }
        
        res.result.du_lieu_khai_bao.tinh_trang = tinhTrang || "An toàn";
        res.result.du_lieu_khai_bao.tieuchi1 = "";
        res.result.du_lieu_khai_bao.tieuchi2 = "";
        // res.result.du_lieu_khai_bao.tieuchi3 = "";
        // res.result.du_lieu_khai_bao.tieuchi4 = "";
        // res.result.du_lieu_khai_bao.tieuchi5 = "";
        res.result.du_lieu_khai_bao.ngung_hoat_dong = !res.result.hoat_dong || !res.result.hoat_dong.ngung_hoat_dong ? 'false' :  'true';
        objJsonB64 = Buffer.from(
          JSON.stringify(res.result.du_lieu_khai_bao)
        ).toString("base64");
        prefillSurvey = await SurveyApi.getPrefillId({ data: objJsonB64 });
        //debugger;
      }
      let pathLocation =
        location.protocol + "//" + location.host + "/admin/DangKyDDAT/success?src=khaibaongay";

      let params = {
        prefillData: prefillSurvey.result,
        appCode: "Tourism",
        callbackUrl: pathLocation,
        env: window.MyConfig.surveyDailyEnv
      };

      let resCode = await AccountApi.generateHashCode(params);
      // console.log(resCode.result);

      this.mData.dataDefault.links +=
        window.MyConfig.surveyDaily +
        "prefillId=" +
        prefillSurvey.result +
        "&hashCode=" +
        resCode.result.toString().toLowerCase() +
        "&appCode=Tourism" +
        "&env=" + window.MyConfig.surveyDailyEnv + 
        "&callbackUrl=" +
        encodeURIComponent(pathLocation);
      // debugger;
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
  },
  created: function () {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-daily"
    ) {
      this.fn_getDailyDataById(this.$router.currentRoute.params.id);
    } else if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {
    window.redirectToDangKyDDAT = async (url, type) => {
      DiemDenAnToanApi.clearCache();
      if (type === 'khaibaoantoan') {
        window.toastr.success("Bạn đã khai báo an toàn thành công ngày hôm nay");
      } else {
        this.currentUser = MethodService.getCurrentUser();
          if (this.$router.currentRoute.path == this.$router.currentRoute) {
            let res = await DiemDenAnToanApi.list({filters: 'nguoi_tao_id=' + this.currentUser.id, fields: "loai_diem_den"});
            if (res.result && res.result.length > 0) {
              if (!('hotel,tourist_villa,tourist_apartment,tourist_cruise,motel,homestay'.includes(res.result[0].loai_diem_den))) {
                $(".fa-calendar-check-o").parent().hide();
                $(".icon-calendar").parent().hide();
              }
              else
              {
                $(".fa-calendar-check-o").parent().show();
                $(".icon-calendar").parent().show();
              }   
            }
          }
        window.toastr.success("Cập nhật đơn vị thành công");
      }
      await this.$router.push(url);
      window.location.reload();
    }
  },
};
</script>
<style scoped>
.card {
  position: relative;
  margin-bottom: 0;
}
.card-body-custom{
  padding: 0;
}

.card::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 70%;
  background-image: url("~/img/safe-travel.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.1;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.div-btn{
  position: relative;
  width: 100%;
  height: 50px;
  padding: 10px 0 0px 0;
  background-color: #fff;
}
.popover-css{
  position: absolute;
  left: 10px;
}
.warning-text{
  float: left;
  font-size: 12px;
  margin-left: 20px;
}
.warning-text:hover{
  text-decoration: none;
}
a{
  text-decoration: underline;
}
a:hover{
  /* text-decoration: none; */
}
.alert-message{
  word-break: initial;
  padding: 10px;
}
.btn-back{
  position: absolute;
  left: 46%;
  top: 10%;
  /* margin-left: -15px; */
}
.animated{
  margin-left: -5px;
  margin-right: -5px;
}
</style>
